import CollapsableComponent from '@components/CollapsableComponent';
import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import FilterComponent from '@components/Default/Search/FilterComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import SelectableDataComponent from '@components/SelectableDataComponent';
import StatusWarning from '@components/StatusWarning';
import Table, { ITableColumn } from '@components/TableComponent';
import UserRadioSelect from '@components/userRadioSelectComponent';
import NotificationComponent from '@helpers/_showNotifications';
import { IAuditor as AuditorInterface } from '@interfaces/ehss/Auditor';
import { IProcess } from '@interfaces/ehss/Process';
import { IField } from '@interfaces/global/config-global';
import { IUser as UserInterface } from '@interfaces/IUser';
import IUserExtraFieldsState from '@interfaces/IUserExtraFieldsState';
import AppContext from '@services/Context';
import AuditorService from '@services/ehss/Auditor';
import ProcessService from '@services/ehss/Process';
import ConfigService from '@services/global/Config';
import UserService from '@services/UserService';
import { Routes } from '@src/helpers/_routes';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Avatar, Button, Checkbox, Col, Modal, Row } from 'antd';
import React from 'react';
import { Link, Redirect } from 'react-router-dom';

const confirm = Modal.confirm;
interface IAuditorsContainerPropType {
  history: { replace: Function };
  match: any;
}

interface IAuditorsContainerStateType extends IUserExtraFieldsState {
  auditedsByAuditor: number;
  auditedsGoal: number;
  auditorsLackingAuditeds: boolean,
  auditorsLackingAudits: boolean,
  auditsAlreadySaved: IProcess[];
  processesData: IProcess[];
  auditsGoal: number;
  curOffset?: string;
  curUsersOffset?: string,
  filteredTableData: AuditorInterface[];
  haveAuditorSelected: boolean;
  iconLoading?: boolean;
  isLoading: boolean;
  loadingAudits: boolean;
  loadingMoreAuditors: boolean;
  loadingMoreUsers: boolean;
  loadingTable?: boolean;
  loadingUsersBySearch: boolean;
  noAudited?: boolean;
  noProcess?: boolean;
  noUserFound: boolean;
  savingAuditor: boolean;
  searchAuditor: string;
  searchUser: string;
  selectedAuditor: string,
  selectedAuditorObject?: AuditorInterface;
  serverResponse: any;
  showAuditsModal: boolean;
  showFormModal: boolean;
  statusWanted?: any;
  tableData: AuditorInterface[];
  totalData: number,
  totalShowData?: number;
  usersAmount: number;
  usersData: any[];
  userSelectedItem: string;
  registerModalTableColumns: ITableColumn[];
  isCollapsed: boolean;
  userAmount: number,
  loadingMoreProcesses: boolean,
  curProcessesOffset?: string,
  userRoles?: any;
};

const tableColumns = [
  {
    title: 'table.users.name',
    dataIndex: 'name',
    key: 'name',
    width: '30%',
  },
  {
    title: 'table.auditors.registration',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: 'table.auditors.processes',
    dataIndex: 'audits',
    key: 'audits',
  },
  {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '10%',
  }
];


const CheckboxGroup = Checkbox.Group;
const radioComponentTableColumnSize = 200;

class Auditors extends React.Component<IAuditorsContainerPropType, IAuditorsContainerStateType> {

  private idUnit: any = undefined;
  private _auditorService: AuditorService = new AuditorService();
  private _userService: UserService = new UserService();
  private _configService: ConfigService = new ConfigService();
  private _processService: ProcessService;

  constructor(props: any) {
    super(props);
    this._processService = new ProcessService();

    this.state = {
      isLoading: true,
      showFormModal: false,
      iconLoading: false,
      auditorsLackingAuditeds: false,
      auditorsLackingAudits: false,
      tableData: [],
      usersData: [],
      totalShowData: 5,
      totalData: 0,
      usersAmount: 0,
      filteredTableData: [],
      curOffset: undefined,
      curUsersOffset: undefined,
      userSelectedItem: '',
      haveAuditorSelected: false,
      loadingUsersBySearch: false,
      loadingMoreUsers: false,
      loadingMoreAuditors: false,
      savingAuditor: false,
      auditsGoal: 0,
      auditedsGoal: 0,
      auditedsByAuditor: 0,
      searchUser: '',
      searchAuditor: '',
      serverResponse: undefined,
      noUserFound: false,
      processesData: [],
      statusWanted: undefined,
      showAuditsModal: false,
      loadingAudits: false,
      selectedAuditor: '',
      selectedAuditorObject: undefined,
      auditsAlreadySaved: [],
      noAudited: undefined,
      noProcess: undefined,
      loadingTable: false,
      extraFields: new Array<IField>(),
      extraFieldsCheckboxesIds: new Array<string>(), //used to control which checkboxes are checked
      visibleExtraFieldsIds: new Array<string>(), //used to control which columns are visible
      registerModalTableColumns: new Array<ITableColumn>(),
      isCollapsed: true,
      userAmount: 0,
      loadingMoreProcesses: false,
      curProcessesOffset: undefined,
    }

    this.getProcesses = this.getProcesses.bind(this);
    this.onSeeMoreProcesses = this.onSeeMoreProcesses.bind(this);
  }

  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    this.setState({ isLoading: true });
    await this.getAuditors(true);
    await this.setExtraFieldsState();
    await this.setRegisterModalTable();
  }

  //#region auditor container methods
  setUnit(unitId: string) {
    this.idUnit = unitId;
  }

  permissionApi = (accept: string[], roles: any) => {
    for (let a of accept) {
      if (roles.find((s: any) => s == a) != null) {
        return true
      }
    }
    return false
  }

  toggleFormModal = () => {
    if (!this.state.showFormModal) {
      this.getUsers(true, '');
    }
    this.setState({
      usersData: [],
      userSelectedItem: '',
      haveAuditorSelected: false,
      searchUser: '',
      showFormModal: !this.state.showFormModal,
      noUserFound: false,
      loadingUsersBySearch: true,
      serverResponse: undefined,
    });
  };

  loadMoreAuditors = async () => {
    this.getAuditors(false);
  }

  getAuditors = async (reset: boolean) => {
    this.setState({ showFormModal: false, loadingMoreAuditors: true });
    const { tableData } = this.state;

    if (reset) {
      this.setState({
        curOffset: undefined,
        showFormModal: false,
        isLoading: true,
        tableData: []
      });
    }
    try {
      let data: any = await this._auditorService.paging(
        {
          unit: this.idUnit,
          hasNoAudited: this.state.noAudited,
          hasProcess: !this.state.noProcess,
          to: undefined,
          from: undefined,
          search: this.state.searchAuditor,
          limit: 6,
          offset: this.state.curOffset
        });

      let newDataTableCreate: AuditorInterface[] = [];
      if (data != undefined) {
        if (!reset) {
          newDataTableCreate = tableData || [];
        }
        newDataTableCreate = newDataTableCreate.concat(data.items);
      }

      this.setState({
        userAmount: data.count,
        tableData: newDataTableCreate,
        isLoading: false,
        iconLoading: false,
        totalData: (data != undefined) ? data.count : 0,
        curOffset: (data != undefined) ? data.offset : undefined,
        loadingMoreAuditors: false,
      });

    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
      this.setState({
        isLoading: false,
        loadingMoreAuditors: false,
      });
    }

    this.checkAuditorsLackingAuditeds();
    this.checkAuditorsLackingAudits();
  };

  getProcesses = async (reset: boolean, showLoading: boolean) => {
    const {
      curProcessesOffset,
    } = this.state;

    this.setState({
      loadingAudits: reset,
      loadingMoreProcesses: !reset,
    });


    if (reset) {
      this.setState({
        curProcessesOffset: undefined
      });
    }

    try {
      if (this.idUnit) {
        const data: any = await this._processService.paging({
          unit: this.idUnit,
          to: undefined,
          from: undefined,
          limit: 15,
          offset: curProcessesOffset,
        });

        const dataTableCreate: any[] = [];
        data.items.map(async (item: any) => {
          dataTableCreate.push({
            key: item.id,
            name: item.name,
            code: item.code,
            id: item.id,
            loading: false,
          })
        });

        let nextProcessesData: any[] = [];

        if (!reset) {
          nextProcessesData = this.state.processesData || [];
        }
        nextProcessesData = nextProcessesData.concat(dataTableCreate);
        this.setState({
          loadingAudits: false,
          processesData: nextProcessesData,
          curProcessesOffset: data.offset || undefined,
        });
      }

      else throw new Error("No unit set");

    } catch (error) {
      console.warn('Erroooooou', error);
      this.setState({
        isLoading: false,
        loadingAudits: false,
        loadingMoreProcesses: false,
      });
    }
    this.setState({ loadingMoreProcesses: false });
  }
  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    await this.setState({
      loadingUsersBySearch: true,
      searchUser: SearchValue,
    })
    try {
      this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };

  handleUserSearchChange = (e: any) => {
    this.setState({
      searchUser: e.target.value,
    })
  }

  loadMoreUsers = () => {
    this.setState({ loadingMoreUsers: true });
    this.getUsers(false, this.state.searchUser);
  }

  getUsers = async (reset: boolean, user?: string) => {
    if (reset) {
      this.setState({
        curUsersOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        const data = await this._userService.paging({
          unit: this.idUnit,
          noAuditor: true,
          to: undefined,
          from: undefined,
          search: user,
          disabled: false,
          limit: 6,
          offset: this.state.curUsersOffset,
        });

        let nextUsersData: UserInterface[] = [];

        if (!reset) {
          nextUsersData = this.state.usersData || [];
        }
        nextUsersData = nextUsersData.concat(data.items);
        this.setState({
          usersData: nextUsersData,
          curUsersOffset: data.offset,
          noUserFound: nextUsersData.length == 0,
          loadingMoreUsers: false,
          usersAmount: data.count,
          loadingUsersBySearch: false,
        });
      }
      else {
        this.setState({
          usersData: [],
          curUsersOffset: undefined,
          loadingMoreUsers: false,
          loadingUsersBySearch: false,
          noUserFound: false,
        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  }

  onSubmit = async () => {
    try {
      let nextTableData: AuditorInterface[] = [];

      this.setState({
        isLoading: false,
        showFormModal: false,
        tableData: nextTableData,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    }
  };

  // ABRE O MODAL DE DELETAR UM PRODUTO
  deleteAudited = async (id: string) => {
    const { tableData } = this.state;
    let nextTableData = tableData.filter((item: AuditorInterface) => item.id !== id);
    try {

      await this._auditorService.deleteById(id, { force: false });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.auditorDelete"));
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });

      this.checkAuditorsLackingAuditeds();
      this.checkAuditorsLackingAudits();
    } catch (e) {
      await this.showDeleteConfirm(() => this.forceDelete(id, nextTableData), e)
      console.error(e);
    }
  };
  forceDelete = async (userId: string, nextTableData: any) => {
    try {
      await this._auditorService.deleteById(userId, { force: true });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.auditorDelete"));
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.delete"), error);
    }
  }

  showDeleteConfirm(onDelete: Function, error: string[]) {

    let listErrors: JSX.Element[] = []
    for (let [idx, items] of error.entries()) {
      listErrors.push(
        <div key={idx}>{items}</div>
      )
    }
    confirm({
      title: I18n.l("labels.descriptionDeleteAuditor").toUpperCase(),
      content: (listErrors),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  onSubmitUser = async () => {
    this.setState({ savingAuditor: true });
    const { userSelectedItem, tableData } = this.state;

    try {
      const user = this.state.usersData.filter((i: UserInterface) => i.id === userSelectedItem)[0];
      const response = await this._auditorService.create(user.id);

      const nextTableData: any = tableData || [];
      nextTableData.push(response);

      this.setState({
        showFormModal: false,
        tableData: nextTableData,
        savingAuditor: false,
      });

      this.checkAuditorsLackingAudits();
      this.checkAuditorsLackingAuditeds();
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.auditorSuccess"));
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.select"), error);
      this.setState({
        savingAuditor: false,
      });
    }
  };

  checkAuditorsLackingAuditeds = async () => {
    const { tableData, auditedsByAuditor } = this.state;

    let auditorsLacking = false;

    for (let i = 0; i < tableData.length; i++) {
      const item = this.state.tableData[i]
      if (item.auditor.auditeds == undefined) {
        auditorsLacking = true;
        break;
      }
      auditorsLacking = item.auditor.auditeds.length < auditedsByAuditor;
      if (auditorsLacking == true)
        break;
    }

    this.setState({
      auditorsLackingAuditeds: auditorsLacking,
    });
  };

  checkAuditorsLackingAudits = async () => {
    const { tableData } = this.state;

    let lackingAudits: boolean = false;

    if (!!tableData) {
      for (let i = 0; i < tableData.length; i++) {
        const item = tableData[i];
        if (item.auditor == undefined) {
          lackingAudits = true;
          break;
        }
        if (item.auditor.processes == undefined || item.auditor.processes.length == 0) {
          lackingAudits = true;
          break;
        }
      }
    }

    this.setState({ auditorsLackingAudits: lackingAudits });

  }

  formatAuditorDataToTable = (users: AuditorInterface[]) => {
    const nextData: any[] = [];
    users.map((auditor: AuditorInterface) => {
      let linkAuditorDetails =
        <div>
          {auditor.auditor.auditeds === undefined ?
            <Col sm={24} md={4} lg={4}>
              <TableNoAuditorWarning>
                <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" />
              </TableNoAuditorWarning>
            </Col>
            : <Col></Col>
          }
          <Col sm={24} md={12} lg={12}>
            <Link to={`${Routes.auditors}/${auditor.id}`}>{auditor.name}</Link>
          </Col>
        </div>;

      let processInfo =
        <Col >
          <TableNoAuditorWarning>
            <a href="#" onClick={() => this.toggleProcessModal(auditor.id || '')}>{I18n.l('table.audits.linkProcess')}</a>
            <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" className={"goepik-small-left-margin"} />
          </TableNoAuditorWarning>
        </Col>;

      // if has process, overrides the processInfo object
      if (auditor != undefined) {
        if (auditor.auditor != undefined) {
          if (auditor.auditor.processes != undefined) {
            if (auditor.auditor.processes.length > 0) {
              processInfo =
                <Col sm={24} md={12} lg={12}>
                  <a href="#" onClick={() => this.toggleProcessModal(auditor.id || '')}>{I18n.l('table.audits.seeProcesses')}</a>
                </Col>
            }
          }
        }
      }

      nextData.push({
        id: auditor.id,
        name: linkAuditorDetails,
        username: auditor.username,
        audits: processInfo,
      })
    });


    return nextData;
  }

  openEditModal = () => {
    this.setState({ showFormModal: true });
  };

  onRadioItemSelectionChange = async (userId: string) => {
    this.setState({
      haveAuditorSelected: !!userId,
      userSelectedItem: userId,
    });
  }

  filterData = async (status: any) => {

    if (status == undefined) {
      await this.setState({
        isLoading: true,
        loadingTable: true,
        statusWanted: status,
        noProcess: undefined,
        noAudited: undefined,
      })
    }

    if (status == 1) {
      await this.setState({
        isLoading: true,
        loadingTable: true,
        noProcess: true,
        noAudited: undefined,
        statusWanted: status
      })
    }

    if (status == 2) {

      await this.setState({
        isLoading: true,
        loadingTable: true,
        noProcess: undefined,
        noAudited: true,
        statusWanted: status
      })
    }
    try {
      this.getAuditors(true);
    }
    catch (err) {
      console.log(err)
    }
  }

  getFilterLabel(orderId: number) {
    let label = "all";
    if (orderId == 1) {
      label = "auditorswithoutaudits";
    }
    if (orderId == 2) {
      label = "auditorswithoutauditeds";
    }
    return label;
  }

  searchChange = async (event: any) => {
    this.setState({
      searchAuditor: event.target.value
    })
  };

  searchData = async (event: any) => {
    event.preventDefault();
    await this.setState({
      searchAuditor: event.target.find.value,
      loadingTable: true
    })
    if (event === '') {
      await this.setState({
        searchAuditor: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    this.getAuditors(true);
  }

  toggleProcessModal = async (auditorId?: string) => {
    this.setState({ selectedAuditor: auditorId || '' })

    await this.updateSelectedAuditorObject();
    if (auditorId) this.getAuditorAuditsIds(auditorId);

    this.getProcesses(true, true);

    this.setState({
      showAuditsModal: !this.state.showAuditsModal,
    });
  }

  getAuditorAuditsIds = async (auditorId: string) => {
    this.setState({ auditsAlreadySaved: [] });
    const { tableData } = this.state;

    if (tableData != undefined) {
      // debugger
      const person = tableData.filter((item: any) => item.id == auditorId);
      let newAuditsSavedData: any = [];
      if (person[0].auditor != undefined) {

        this.setState({ selectedAuditor: person[0].id || '' });

        if (person[0].auditor.processes != undefined) {
          newAuditsSavedData = person[0].auditor.processes;
        }
      }
      this.setState({ auditsAlreadySaved: newAuditsSavedData })
    }
  }

  setLoadingAuditData = async (auditId: string, loading: boolean) => {
    const { processesData: auditsData } = this.state;

    const audit: any = auditsData.find((item) => {
      return item.id == auditId;
    });
    const indexOf = auditsData.indexOf(audit);

    const newAuditsData: any[] = [...auditsData];
    newAuditsData[indexOf].loading = loading;

    this.setState({ processesData: newAuditsData });
  }

  onRemoveAudit = async (id: string) => {
    const { selectedAuditor } = this.state;
    await this.setLoadingAuditData(id, true);

    try {
      await this._auditorService.processRemove(this.idUnit, selectedAuditor, id);
      this.auditRemoved(id);
      this.setLoadingAuditData(id, false);
    } catch (error) {
      this.setLoadingAuditData(id, false);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), error);
    }
  }

  onAddProcess = async (id: string) => {
    const { selectedAuditor } = this.state;
    this.setLoadingAuditData(id, true);

    try {
      await this._auditorService.processAdd(this.idUnit, selectedAuditor, id);
      this.processAdded(selectedAuditor, id);
      this.setLoadingAuditData(id, false);
    } catch (e) {
      this.setLoadingAuditData(id, false);
    }
  }

  processAdded = async (auditor: string, id: string) => {
    const { auditsAlreadySaved, tableData } = this.state;

    const newAlreadySaved: any[] = [...auditsAlreadySaved];
    newAlreadySaved.push(id);

    const newTableData = [...tableData];
    let auditorIndex = newTableData.findIndex(e => e.id === auditor);
    if (auditorIndex != -1) {
      const newProcesses = newTableData[auditorIndex].auditor.processes ? newTableData[auditorIndex].auditor.processes : []
      newTableData[auditorIndex].auditor = {
        ...newTableData[auditorIndex].auditor,
        processes: [...newProcesses, id]
      }
      // newTableData[auditorIndex].auditor.processes.push(id);
    }
    this.setState({ auditsAlreadySaved: newAlreadySaved, tableData: newTableData });
    this.setProcessesToUser();
  }

  auditRemoved = async (id: string) => {
    const { auditsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...auditsAlreadySaved];
    const index = newAlreadySaved.indexOf(id);
    newAlreadySaved.splice(index, 1);
    this.setState({ auditsAlreadySaved: newAlreadySaved });
    this.setProcessesToUser();
  }

  setProcessesToUser() {
    const { tableData, selectedAuditor, auditsAlreadySaved } = this.state;

    if (tableData != undefined) {
      const person = tableData.filter((item: any) => item.id == selectedAuditor);
      const index = tableData.indexOf(person[0]);

      let newTableData: any = [...tableData];
      if (newTableData[index].auditor != undefined) {
        if (newTableData[index].auditor.processes) {
          newTableData[index].auditor.processes = auditsAlreadySaved;
        }
      }
      this.setState({ tableData: newTableData });
    }
  }

  renderLackingWarning() {
    const { auditorsLackingAudits, auditorsLackingAuditeds } = this.state;

    if (!!auditorsLackingAudits && !!auditorsLackingAuditeds) {
      return (
        <StatusWarning
          title={I18n.l("titles.auditorLackingAuditedsOrAudits")}
          showLineBreak={true}
        />
      )
    }
    else if (!!auditorsLackingAudits) {
      return (
        <StatusWarning
          title={I18n.l("titles.auditorLackingAudit")}
          showLineBreak={true}
        />
      )
    }
    else if (!!auditorsLackingAuditeds) {
      return (
        <StatusWarning
          title={I18n.l("titles.auditorLackingAuditeds")}
          showLineBreak={true}
        />
      )
    }

    return;
  }

  updateSelectedAuditorObject = async () => {
    const { selectedAuditor, tableData } = this.state;
    let selectedUser = undefined;
    selectedUser = await tableData.find((item: any) => item.id === selectedAuditor);
    this.setState({ selectedAuditorObject: selectedUser });
  }

  getSelectedAuditorName() {
    const { selectedAuditorObject } = this.state;
    if (!!selectedAuditorObject)
      return selectedAuditorObject.name;
    return undefined;
  }

  getAuditModalTitle() {
    const { selectedAuditorObject } = this.state;
    if (!!selectedAuditorObject) {
      return I18n.l('audits.titles.auditorWhatAuditsWithName').replace("{name}", selectedAuditorObject.name);
    }
    return I18n.l('audits.titles.auditorWhatAudits');
  }

  //#endregion

  //#region extra fields methods

  //#region EXTRA FIELDS 
  getVisibilityFromState = (fieldId: string): boolean => {
    return this.state.visibleExtraFieldsIds.includes(fieldId);
  }

  onCheckboxGroupChange = async (checkboxList: any) => {
    this.setState({
      extraFieldsCheckboxesIds: checkboxList
    });

    const registerModalTableColumns: ITableColumn[] = this.state.registerModalTableColumns;

    // hides erbody
    registerModalTableColumns.filter(column => column.key !== 'name' && column.key !== "username").map(column => {
      column.isHidden = true
    });

    // FIXME: this is ugly af
    checkboxList.forEach((element: any) => {

      // now that everybody is hidden, show those who are not
      registerModalTableColumns.filter(column => column.key !== 'name' && column.key !== "username").map(column => {
        if (column.key === element) {
          column.isHidden = false;
        }
      });

    });

    this.setState({
      registerModalTableColumns
    });
  }

  setExtraFieldsState = async () => {
    try {
      const dataGlobal = await this._configService.getGLOBAL();
      const extraFields = dataGlobal.userFields;
      this.setState({
        extraFields
      });

      let visibleIds: string[] = [];
      extraFields.forEach((extraField: IField) => {
        if (extraField.id && Boolean(localStorage.getItem(extraField.id)) === true) { // If true, it's visible
          visibleIds.push(extraField.id);
        }
      });

      this.setState({
        visibleExtraFieldsIds: visibleIds,
        extraFieldsCheckboxesIds: visibleIds,
      });

    } catch (error) {
      console.error("error on fetching extra fields", error)
    }
  }

  toggleCollapsableInstructions = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }

  getRegisterModalTableInitialFields = () => {
    return [
      {
        title: 'table.users.name',
        dataIndex: 'name',
        key: 'name',
        width: radioComponentTableColumnSize,
      },
      {
        title: 'table.auditors.registration',
        dataIndex: 'username',
        key: 'username',
        width: radioComponentTableColumnSize,
      },
    ] as ITableColumn[];
  }

  setRegisterModalTable = async () => {
    this.setState({
      registerModalTableColumns: []
    });

    const _tableColumns = this.getRegisterModalTableInitialFields();
    let _newColumn: ITableColumn;

    if (this.state.extraFields) {
      this.state.extraFields.forEach((field: IField) => {
        if (field.id) {
          _newColumn = {
            title: String(field.name),
            dataIndex: field.id,
            key: field.id,
            isHidden: !this.getVisibilityFromState(field.id),
            width: radioComponentTableColumnSize
          }
          _tableColumns.push(_newColumn);
        }
      });
    }

    this.setState({
      registerModalTableColumns: _tableColumns,
    });
  }

  onSeeMoreProcesses() {
    this.getProcesses(false, false);
  }


  //#endregion

  render() {
    const {
      isLoading,
      showFormModal,
      noUserFound,
      tableData,
      usersData,
      serverResponse,
      haveAuditorSelected,
      loadingMoreUsers,
      loadingMoreAuditors,
      savingAuditor,
      loadingUsersBySearch,
      userSelectedItem,
      searchUser,
      searchAuditor,
      processesData: auditsData,
      showAuditsModal,
      loadingAudits,
      auditsAlreadySaved,
      curProcessesOffset,
      loadingMoreProcesses,
    } = this.state;

    const roles: any = JSON.parse(localStorage.getItem('roles') || '');
    const UID: any = localStorage.getItem('userId');

    if (this.permissionApi(['AUDITOR'], roles) && !this.permissionApi(['ADMIN'], roles)) {
      return (
        <Redirect
          to={`${Routes.auditors}/${UID}`}
          from={Routes.auditors}
        />
      )
    }

    if (!(this.state.loadingTable)) {
      if (!!isLoading) {
        return (
          <Page>
            <AppContext.Consumer>
              {({ activeUnitId }) => (
                this.setUnit(activeUnitId),
                <Col>{I18n.l('common.loadingTable')}</Col>
              )}
            </AppContext.Consumer>
          </Page>
        );
      }
    }

    let extraFieldsCheckboxesRows: JSX.Element[]; //All checkboxes
    let collapsableContent: JSX.Element; // Variable content inside the collapsable component
    if (this.state.extraFields && this.state.extraFields.length > 0) {
      extraFieldsCheckboxesRows = this.state.extraFields.map((el: any) => {
        return (
          <Col key={el.id} span={24} style={{ marginBottom: "1rem" }}>
            <Checkbox value={el.id}>{el.name}</Checkbox>
          </Col>
        )
      });

      collapsableContent = (
        <CheckboxGroup defaultValue={this.state.visibleExtraFieldsIds} onChange={this.onCheckboxGroupChange}>
          <Row>
            {extraFieldsCheckboxesRows}
          </Row>
        </CheckboxGroup>
      );
    }
    else {
      collapsableContent = (
        <p style={{ marginTop: "1rem" }} className="goepik-text-lightGray-bold">{I18n.l('assignment.tableWarning')}</p>
      )
    }

    return (
      <Page>
        <AppContext.Consumer>
          {({ activeUnitId }) => (
            this.setUnit(activeUnitId),
            <Wrapper>
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.toggleFormModal}
                    buttonText={I18n.l('common.register') + " " + I18n.l('labels.auditor')}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.searchData}
                    placeholder='form.placeholders.auditorsSearch'
                    defaultValue={searchAuditor}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>
              <FilterComponent
                label={I18n.l("auditors.filter.label")}
                onClick={this.filterData}
                buttons={{
                  text: {
                    all: 'auditors.filter.button.label.all',
                    active: 'auditors.filter.button.label.auditorswithoutauditeds',
                    deactive: 'auditors.filter.button.label.auditorswithoutaudits',
                  }
                }}
                auditorsFilter={true}
                curTicketStatus={this.state.statusWanted || undefined}
              />
              {/* AUDITORS TABLE */}
              {isLoading && (
                <span>{I18n.l('common.loadingTable')}</span>)
              }
              {tableData.length > 0 && (
                <div className="goepik-component-tablesize">
                  {this.renderLackingWarning()}
                  <Table
                    columns={tableColumns}
                    data={this.formatAuditorDataToTable(tableData)}
                    onDelete={this.deleteAudited}
                    noPagination={true}
                    showConfirmationModal={false}
                  />
                  <br />
                  {this.state.userAmount >= 6 && (
                    <Button
                      className="loading-more"
                      type="primary"
                      size='large'
                      ghost
                      loading={loadingMoreAuditors}
                      onClick={this.loadMoreAuditors}>{I18n.l('common.seeMore')}</Button>
                  )}
                </div>

              )}
              {/* WHEN THERE'S NO DATA */}
              {tableData.length === 0 && !isLoading && <p>{I18n.l('common.noResult')}</p>}
              {/* CHOOSE USER AS AUDITOR MODAL */}
              {showFormModal && (
                <LargeModal>
                  <Modal visible={showFormModal} wrapClassName={"large-modal"} footer={false} closable={false} >
                    <ModalTitle>{I18n.l('form.titles.auditorsSelectForm')}</ModalTitle>
                    <ModalContent>
                      <SearchAudited>
                        <SearchComponent
                          onSubmit={this.handleUsersSearch}
                          placeholder='form.placeholders.alertsSearch'
                          buttonText='form.buttons.search'
                        />
                      </SearchAudited>
                      <CollapsableComponent style={{ marginTop: '1rem' }} title={I18n.l('assignment.tableConfig')} collapsed={this.state.isCollapsed} onClick={this.toggleCollapsableInstructions}>
                        <div style={{ marginBottom: '1rem' }}>
                          <span >{I18n.l('assignment.tableInstructions')}</span>
                        </div>
                        {collapsableContent}
                      </CollapsableComponent>
                      {usersData.length > 0 && (
                        <UserRadioSelect
                          columns={this.state.registerModalTableColumns}
                          data={usersData}
                          itemSelectionChanged={(userId: string) => this.onRadioItemSelectionChange(userId)}
                          loadingMoreData={loadingMoreUsers}
                          hasMoreData={this.state.curUsersOffset != undefined && this.state.curUsersOffset != ''}
                          onShowMore={this.loadMoreUsers}
                          valueSelected={userSelectedItem}
                        >
                        </UserRadioSelect>
                      )}
                      {usersData.length == 0 && loadingUsersBySearch === false && noUserFound == true && searchUser.length == 0 && (
                        <p className="goepik-component-padding">{I18n.l('titles.noUserRegistered')}</p>
                      )}
                      {loadingUsersBySearch === true && (
                        <p className="goepik-component-padding">{I18n.l('common.loadingTable')}</p>
                      )}
                      {(usersData && !!noUserFound && usersData.length === 0 && searchUser.length > 0 && loadingUsersBySearch == false) && (
                        <p className="goepik-component-padding">{I18n.l('common.noResult')}</p>
                      )}
                      <p className="goepik-component-padding"></p>
                      <Row type="flex" justify="end">
                        <Button className="main-button" type="primary" ghost size="large" onClick={this.toggleFormModal}>
                          {I18n.l('common.cancel')}
                        </Button>
                        <Button className="main-button" type="primary" size="large" loading={savingAuditor} onClick={() => this.onSubmitUser()} disabled={!haveAuditorSelected}>
                          {I18n.l('common.select')}
                        </Button>
                      </Row>

                    </ModalContent>
                  </Modal>
                </LargeModal>
              )}
              {showAuditsModal && (
                <SelectableDataComponent
                  title={
                    this.getAuditModalTitle()
                  }
                  data={auditsData}
                  showModal={showAuditsModal}
                  loadingData={loadingAudits}
                  auditorAuditsIds={auditsAlreadySaved}
                  onItemRemoved={this.onRemoveAudit}
                  onItemSelected={this.onAddProcess}
                  serverResponse={serverResponse}
                  onToggleFormModal={() => this.toggleProcessModal()}
                  hasMoreProcessesToSave={curProcessesOffset != undefined && curProcessesOffset !== ''}
                  onSeeMorePressed={this.onSeeMoreProcesses}
                  loadingSeeMore={loadingMoreProcesses}
                />
              )}

            </Wrapper>
          )}
        </AppContext.Consumer>
      </Page >
    );
  }
}



const LargeModal = styled.div`
    .large-modal{
        width: 45%;
    }
`;

const TableNoAuditorWarning = styled.div`
    span{
        margin-right:8px;
    }
`;
const SearchAudited = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
    .register-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    hr{
        opacity: .6;
    }

`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;


const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;

const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
`;

const ModalContent = styled.div`
  width: 100%;
    .goepik-component-padding{
        color:#a3a3a3;
        font-weight:bold;
        font-size:14px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .searchBtn{
        border-color: #1890ff;
        color: #1890ff;
    }
    .margied-elements{
        margin-left:10px;
    }
`;

export default Auditors;
